import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  error: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "red",
  },
});

type ErrorControlledProps = {
  error: string | undefined;
};

const ErrorControlled = ({error}: ErrorControlledProps) => {
  const classes = useStyles();
  return (
    <div className={classes.error}>{error && <article>{error}</article>}</div>
  );
};

export default ErrorControlled;
